import {Product} from '@/src/core/domain/entities/product'
import {CatalogProductsList} from '@/src/features/catalog/product-list/list'
import React from 'react'

export const ProductsListContainer = ({products}: {products: Product[]}) => {
  return <CatalogProductsList products={products} />
}
